import deAt from './de-AT.json';
import deDe from './de-DE.json';
import enGb from './en-GB.json';
import enUs from './en-US.json';
import esMx from './es-MX.json';
import frFr from './fr-FR.json';
import itIt from './it-IT.json';
import jaJp from './ja-JP.json';
import koKr from './ko-KR.json';
import ptBr from './pt-BR.json';
import zhCn from './zh-CN.json';
import zhHk from './zh-HK.json';
import thTH from './th-TH.json';
import viVN from './vi-VN.json';

export default {
  getTranslations(locale) {
    const settings =
      global.window.reactSettings ||
      global.window.reactSettingsExhibitorscarousel ||
      global.window.reactSettingsExhibitorHub ||
      global.window.reactSettingsTasklist ||
      global.window.reactSettingsProductsDirectory ||
      global.window.reactSettingsProductDetails ||
      global.window.reactSettingsArtistsDirectory ||
      global.window.reactSettingsArtistDetails ||
      global.window.reactSettingsExhibitorHubProfile ||
      global.window.reactSettingsManageAdminRoles ||
      global.window.reactSettingsExhibitorHubCompanyAdmin;
    if (
      !settings ||
      !settings.props ||
      !settings.props.localisation ||
      !settings.props
    ) {
      return (
        localisation[locale] || localisation[locale] || localisation['en-GB']
      ); // Default to english // Default to english
    }

    return (
      settings.props.localisation[locale] ||
      settings.props.localisation['en-GB']
    ); // Default to english
  },
};

export const localisation = {
  'de-AT': deAt,
  'de-DE': deDe,
  'en-GB': enGb,
  'en-US': enUs,
  'es-MX': esMx,
  'fr-FR': frFr,
  'it-IT': itIt,
  'ja-JP': jaJp,
  'ko-KR': koKr,
  'pt-BR': ptBr,
  'zh-CN': zhCn,
  'zh-HK': zhHk,
  'th-TH': thTH,
  'vi-VN': viVN,
};
